import React from 'react';
import { createRoot } from 'react-dom/client';

import { AdminApp } from './AdminApp';
import { App } from './App';
import { I18nProvider } from './i18n';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('missing #root');

// /admin is a separate, unlisted tool — not part of the game's own
// navigation, reached only by going there directly. No router needed for one
// extra path.
const isAdmin = window.location.pathname.replace(/\/+$/, '') === '/admin';

/**
 * Offline support, in production only — a service worker sitting in front of
 * a dev server would serve stale modules and fight HMR. Failures are ignored
 * on purpose: not being installable (an unsupported browser, a private
 * window, a host without HTTPS) is a missing nicety, not a broken app.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

createRoot(container).render(
  <React.StrictMode>
    {isAdmin ? (
      <AdminApp />
    ) : (
      <I18nProvider>
        <App />
      </I18nProvider>
    )}
  </React.StrictMode>,
);
